module.exports = "/images/lines-6.jpg";